import React, { createContext, useCallback, useEffect, useState } from "react";
import cookies from "react-cookies";
import jwt from "jsonwebtoken"; // 👈 usar en frontend
import { useLazyQuery } from "@apollo/client";
import { GET_USER } from "./requests";
import { message } from "antd";
import { useHistory, useLocation } from "react-router-dom"; // v5.2.1

export const UserContext = createContext({});

const UserProvider = ({ children }) => {
  const [user, setUser] = useState("Loading");
  const [isLogged, setIsLogged] = useState(false);

  const history = useHistory();
  const location = useLocation();

  const [
    userQuery,
    {
      data: userData,
      loading: loadingUser,
      error: userError,
      refetch: userRefetch,
    },
  ] = useLazyQuery(GET_USER, { fetchPolicy: "network-only" });

  // Enviar a /login con ?next=<ruta-actual>
  const goLogin = useCallback(() => {
    const onLogin = location.pathname === "/login";
    const next = encodeURIComponent(location.pathname + location.search || "/");
    if (!onLogin) {
      message.error("Se ha cerrado la sesión.");
      history.replace(`/login?next=${next}`);
    }
  }, [history, location.pathname, location.search]);

  const logout = useCallback(() => {
    cookies.remove("token", { path: "/" });
    setUser(null);
    setIsLogged(false);
    goLogin();
  }, [goLogin]);

  const getUser = useCallback(() => {
    const token = cookies.load("token");
    const tokenPayload = token ? jwt.decode(token, {}) : undefined;

    if (tokenPayload?.id) {
      userQuery({ variables: { id: tokenPayload.id } });
    } else {
      setUser(null);
      setIsLogged(false);
    }
  }, [userQuery, logout]);

  // Manejo de error de la query
  useEffect(() => {
    if (userError) {
      message.error("Ha habido un error cargando el perfil!");
      logout();
    }
  }, [userError, logout]);

  // Setear usuario cuando llega la data
  useEffect(() => {
    if (userData?.user) {
      setUser(userData.user);
      setIsLogged(true);
    }
  }, [userData]);

  // Redirigir fuera de /login si ya está logueado
  useEffect(() => {
    if (isLogged && location.pathname === "/login") {
      const params = new URLSearchParams(location.search);
      const next = params.get("next") || "/";
      history.replace(next);
    }
  }, [isLogged, location.pathname, location.search, history]);

  // Cargar usuario al montar
  useEffect(() => {
    getUser();
  }, [getUser]);

  return (
    <UserContext.Provider
      value={{
        user,
        isLogged,
        userRefetch,
        loadingUser,
        getUser,
        setIsLogged,
        logout,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export default UserProvider;
